import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03ff3f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manage-account-backoffice"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-capitalized" }, " Accounts ", -1))
const _hoisted_3 = { class: "row p-4" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-dash-circle-fill text-danger" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-plus-lg" }, null, -1))
const _hoisted_10 = { class: "pointer-sub ms-2" }
const _hoisted_11 = { class: "d-flex p-4 flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitInput = _resolveComponent("MrUiKitInput")!
  const _component_MrUiKitAddField = _resolveComponent("MrUiKitAddField")!
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitCard = _resolveComponent("MrUiKitCard")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MrUiKitCard, {
          headerClasses: ['border-bottom'],
          bodyClasses: ['p-0']
        }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_MrUiKitAddField, {
                modelValue: _ctx.accounts,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accounts) = $event)),
                template: _ctx.template,
                fieldClasses: ['d-flex']
              }, {
                default: _withCtx(({index}) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_MrUiKitInput, {
                      modelValue: _ctx.accounts[index].email,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.accounts[index].email) = $event),
                      key: index
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                "button-remove": _withCtx(({click}) => [
                  _createElementVNode("div", {
                    class: "mt-2 ms-2 button-remove",
                    onClick: click
                  }, _hoisted_7, 8, _hoisted_5)
                ]),
                "button-add": _withCtx(({click}) => [
                  _createElementVNode("div", {
                    onClick: click,
                    class: "text-primary button-add"
                  }, [
                    _hoisted_9,
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t('common.fields.addAccount')), 1)
                  ], 8, _hoisted_8)
                ]),
                _: 1
              }, 8, ["modelValue", "template"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_MrUiKitButton, { onClick: _ctx.onSave }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('common.operations.save')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}